// Static content — easily editable by the artist
export const SPOTIFY_ALBUMS = [
  { id: "3R4pt8bdbnjM7LjnMQmMRJ", title: "Contro", year: "2025" },
  { id: "7LHgQdTn1pAqSj7uF3Hg0h", title: "Jusqu'au lever du jour", year: "2025" },
  { id: "2GDpiOvrfiCMbpLu1q2OYV", title: "Riviera Sessions", year: "2024" },
];

export const STREAMING = {
  spotify: "https://open.spotify.com/artist",
  soundcloud: "https://on.soundcloud.com/7okq1za3n536ihcS6C",
  youtube: "https://youtube.com/@oli.vero-studio",
  apple: "https://music.apple.com",
  deezer: "https://www.deezer.com",
};

export const SOCIALS = [
  { name: "Instagram", url: "#", key: "instagram" },
  { name: "Facebook", url: "#", key: "facebook" },
  { name: "TikTok", url: "#", key: "tiktok" },
  { name: "YouTube", url: "https://youtube.com/@oli.vero-studio", key: "youtube" },
  { name: "Spotify", url: "https://open.spotify.com/artist", key: "spotify" },
  { name: "SoundCloud", url: "https://on.soundcloud.com/7okq1za3n536ihcS6C", key: "soundcloud" },
];

// Clips — real videos from the official YouTube channel
export const CLIPS = [
  { id: "h9-hMCsIZZI", title: "NOTTE ITALIANA" },
  { id: "bKST6vyVUNk", title: "Contro" },
  { id: "2gTTFx9fwsA", title: "Agosto in Piazza" },
  { id: "aLxkkzM0lew", title: "Mon Amour Electro" },
  { id: "JwjnKigLfrE", title: "Cuore Elettrico" },
  { id: "VZoJJsVT_OU", title: "Siamo Più Forti Insieme" },
];

export const GALLERY = [
  "https://images.unsplash.com/photo-1561907484-2cfeddf02318?crop=entropy&cs=srgb&fm=jpg&q=85",
  "https://images.unsplash.com/photo-1528720335838-3f602fea2f0a?crop=entropy&cs=srgb&fm=jpg&q=85",
  "https://images.unsplash.com/photo-1721133073235-e4b5facb27fa?crop=entropy&cs=srgb&fm=jpg&q=85",
  "https://images.unsplash.com/photo-1563784462386-044fd95e9852?crop=entropy&cs=srgb&fm=jpg&q=85",
  "https://images.unsplash.com/photo-1783124758076-9960e08bc576?crop=entropy&cs=srgb&fm=jpg&q=85",
  "https://images.unsplash.com/photo-1781455442841-1efc4877daa9?crop=entropy&cs=srgb&fm=jpg&q=85",
  "https://images.pexels.com/photos/1907092/pexels-photo-1907092.jpeg",
  "https://images.pexels.com/photos/13137879/pexels-photo-13137879.jpeg",
];

export const HERO_BG = "https://images.pexels.com/photos/1117256/pexels-photo-1117256.jpeg";
export const BIO_IMG = "https://customer-assets-gfyr7b9c.emergentagent.net/job_ibiza-electric-1/artifacts/3yosl1fq_file_00000000a8a481f4b51063266d3df55e.png";
